import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "layoutSidenav_nav" }
const _hoisted_2 = {
  class: "sb-sidenav accordion",
  id: "sidenavAccordion"
}
const _hoisted_3 = { class: "sb-sidenav-menu" }
const _hoisted_4 = { class: "nav" }
const _hoisted_5 = { class: "sb-sidenav-menu-heading" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-home" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-user-plus" })
], -1)
const _hoisted_8 = {
  key: 0,
  class: "badge rounded-pill bg-danger text-white ml-1"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-alt" })
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-search" })
], -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-hdd" })
], -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-users-cog" })
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", {
    class: "fa fa-list",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-tag" })
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-search" })
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-shoe-prints" })
], -1)
const _hoisted_17 = {
  class: "collapse",
  id: "submenu1sub1",
  "aria-expanded": "false"
}
const _hoisted_18 = { class: "flex-column nav pl-4" }
const _hoisted_19 = { class: "nav-item" }
const _hoisted_20 = { class: "nav-link p-2 text-truncate" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon uppercase-text" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-question" })
], -1)
const _hoisted_22 = { class: "nav-item" }
const _hoisted_23 = { class: "nav-link p-2 text-truncate" }
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-video" })
], -1)
const _hoisted_25 = { class: "nav-item" }
const _hoisted_26 = { class: "nav-link p-2 text-truncate" }
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-file-pdf" })
], -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-calendar-alt" })
], -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-calendar-alt" })
], -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-users" })
], -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-mail-bulk" })
], -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-envelope" })
], -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-envelope-open-text" })
], -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-envelope-open-text" })
], -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-tag" })
], -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("span", { class: "sb-nav-link-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-envelope" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("nav", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("main")), 1),
          (_ctx.state.userRole === 'site_user')
            ? (_openBlock(), _createBlock("a", {
                key: 0,
                id: "redirectDashboard",
                class: _ctx.state.data.activeTab === 1 ? 'nav-link active' : 'nav-link',
                href: "javascript:void(0)",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.redirectToDashboard && _ctx.redirectToDashboard(...args)))
              }, [
                _hoisted_6,
                _createVNode(_component_router_link, { to: { name: 'admin-dashboard' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("dashboard")), 1)
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.state.userRole === 'site_user')
            ? (_openBlock(), _createBlock("a", {
                key: 1,
                id: "redirectInvitation",
                class: _ctx.state.data.activeTab === 2 ? 'nav-link active' : 'nav-link',
                href: "javascript:void(0)",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.redirectToInvitation && _ctx.redirectToInvitation(...args)))
              }, [
                _hoisted_7,
                _createVNode(_component_router_link, { to: { name: 'admin-invitation' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("invitation")) + " ", 1),
                    (_ctx.invitationCounts)
                      ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(_ctx.invitationCounts), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.state.userRole === 'site_user')
            ? (_openBlock(), _createBlock("a", {
                key: 2,
                id: "redirectMyTemplate",
                class: _ctx.state.data.activeTab === 3 ? 'nav-link active' : 'nav-link',
                href: "javascript:void(0)",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.redirectToMyTemplate && _ctx.redirectToMyTemplate(...args)))
              }, [
                _hoisted_9,
                _createVNode(_component_router_link, { to: { name: 'admin-create-formList' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("my_templates")), 1)
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.state.userRole === 'site_user')
            ? (_openBlock(), _createBlock("a", {
                key: 3,
                id: "redirectLibrary",
                class: _ctx.state.data.activeTab === 4 ? 'nav-link active' : 'nav-link',
                href: "javascript:void(0)",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.redirectToLibrary && _ctx.redirectToLibrary(...args)))
              }, [
                _hoisted_10,
                _createVNode(_component_router_link, { to: { name: 'admin-template-search' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("convorally_library")), 1)
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.state.userRole === 'site_user')
            ? (_openBlock(), _createBlock("a", {
                key: 4,
                id: "redirectMyDrive",
                class: _ctx.state.data.activeTab === 6 ? 'nav-link active' : 'nav-link',
                href: "javascript:void(0)",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.redirectToMyDrive && _ctx.redirectToMyDrive(...args)))
              }, [
                _hoisted_11,
                _createVNode(_component_router_link, { to: { name: 'admin-drive' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("my_drive")), 1)
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.state.userRole === 'site_user')
            ? (_openBlock(), _createBlock("a", {
                key: 5,
                id: "redirectManageGuest",
                class: _ctx.state.data.activeTab === 7 ? 'nav-link active' : 'nav-link',
                href: "javascript:void(0)",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.redirectToManageGuest && _ctx.redirectToManageGuest(...args)))
              }, [
                _hoisted_12,
                _createVNode(_component_router_link, { to: { name: 'admin-manage-guest-user' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("manage_guest_users")), 1)
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.state.userRole === 'site_user')
            ? (_openBlock(), _createBlock("a", {
                key: 6,
                id: "redirectManageGuest",
                class: _ctx.state.data.activeTab === 22 ? 'nav-link active' : 'nav-link',
                href: "javascript:void(0)",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.redirectToManageLineItems && _ctx.redirectToManageLineItems(...args)))
              }, [
                _hoisted_13,
                _createVNode(_component_router_link, { to: { name: 'list-line-item' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('manage_line_items')), 1)
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.state.userRole === 'site_user')
            ? (_openBlock(), _createBlock("a", {
                key: 7,
                id: "redirectManageGuest",
                class: _ctx.state.data.activeTab === 16 ? 'nav-link active' : 'nav-link',
                href: "javascript:void(0)",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.redirectToManageProjectTag && _ctx.redirectToManageProjectTag(...args)))
              }, [
                _hoisted_14,
                _createVNode(_component_router_link, { to: { name: 'manage-project-tag' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("manage_project_tags")), 1)
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.state.userRole === 'admin')
            ? (_openBlock(), _createBlock("a", {
                key: 8,
                class: _ctx.state.data.activeTab === 8 ? 'nav-link active' : 'nav-link',
                href: "javascript:void(0)",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.redirectToEdocDigitize && _ctx.redirectToEdocDigitize(...args)))
              }, [
                _hoisted_15,
                _createVNode(_component_router_link, { to: { name: 'admin-verify-digitize-library' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("manage_edoc_for_digitize")), 1)
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.state.userRole === 'site_user')
            ? (_openBlock(), _createBlock("a", {
                key: 9,
                id: "redirectTutorial",
                class: _ctx.state.data.activeTab === 9 ? 'nav-link active' : 'nav-link collapsed',
                href: "#submenu1sub1",
                "data-toggle": "collapse",
                "data-target": "#submenu1sub1"
              }, [
                _hoisted_16,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("tutorial")), 1)
              ], 2))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_17, [
            _createVNode("ul", _hoisted_18, [
              _createVNode("li", _hoisted_19, [
                _createVNode(_component_router_link, {
                  to: { name: 'admin-tutorial-faq' },
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createVNode("a", _hoisted_20, [
                      _hoisted_21,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("faq")), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createVNode("li", _hoisted_22, [
                _createVNode(_component_router_link, {
                  to: { name: 'admin-tutorial-video' },
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createVNode("a", _hoisted_23, [
                      _hoisted_24,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('video_tutorials')), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createVNode("li", _hoisted_25, [
                _createVNode(_component_router_link, {
                  to: { name: 'admin-tutorial-pdf' },
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createVNode("a", _hoisted_26, [
                      _hoisted_27,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('pdf')), 1)
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          (_ctx.state.userRole === 'site_user')
            ? (_openBlock(), _createBlock("a", {
                key: 10,
                id: "redirectAppointment",
                class: _ctx.state.data.activeTab === 10 ? 'nav-link active' : 'nav-link',
                href: "javascript:void(0)",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.redirectToAppointment && _ctx.redirectToAppointment(...args)))
              }, [
                _hoisted_28,
                _createVNode(_component_router_link, { to: { name: 'admin-appointment' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("my_calendar")), 1)
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.state.userRole === 'admin')
            ? (_openBlock(), _createBlock("a", {
                key: 11,
                id: "redirectSubscriptionPackage",
                class: _ctx.state.data.activeTab === 22 ? 'nav-link active' : 'nav-link',
                href: "javascript:void(0)",
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.redirectToSubscription && _ctx.redirectToSubscription(...args)))
              }, [
                _hoisted_29,
                _createVNode(_component_router_link, { to: { name: 'admin-subscription' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('manage_subscription')), 1)
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.state.userRole === 'admin')
            ? (_openBlock(), _createBlock("a", {
                key: 12,
                class: _ctx.state.data.activeTab === 12 ? 'nav-link active' : 'nav-link',
                href: "javascript:void(0)",
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.redirectToUserActivity && _ctx.redirectToUserActivity(...args)))
              }, [
                _hoisted_30,
                _createVNode(_component_router_link, { to: { name: 'admin-user-activity' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('active_user')), 1)
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.state.userRole === 'admin')
            ? (_openBlock(), _createBlock("a", {
                key: 13,
                class: _ctx.state.data.activeTab === 13 ? 'nav-link active' : 'nav-link',
                href: "javascript:void(0)",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.redirectToBusinessMailTemplate && _ctx.redirectToBusinessMailTemplate(...args)))
              }, [
                _hoisted_31,
                _createVNode(_component_router_link, { to: { name: 'business-mail-template' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('mail_template')), 1)
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.state.userRole === 'admin')
            ? (_openBlock(), _createBlock("a", {
                key: 14,
                class: _ctx.state.data.activeTab === 14 ? 'nav-link active' : 'nav-link',
                href: "javascript:void(0)",
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.redirectToMailEditor && _ctx.redirectToMailEditor(...args)))
              }, [
                _hoisted_32,
                _createVNode(_component_router_link, { to: { name: 'mail-editor' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('send_mail')), 1)
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.state.userRole === 'admin')
            ? (_openBlock(), _createBlock("a", {
                key: 15,
                class: _ctx.state.data.activeTab === 15 ? 'nav-link active' : 'nav-link',
                href: "javascript:void(0)",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.redirectToBusinessMailLog && _ctx.redirectToBusinessMailLog(...args)))
              }, [
                _hoisted_33,
                _createVNode(_component_router_link, { to: { name: 'business-mail-log' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('mail_log')), 1)
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.state.userRole === 'admin')
            ? (_openBlock(), _createBlock("a", {
                key: 16,
                class: _ctx.state.data.activeTab === 19 ? 'nav-link active' : 'nav-link',
                href: "javascript:void(0)",
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.redirectToTutorialManagement && _ctx.redirectToTutorialManagement(...args)))
              }, [
                _hoisted_34,
                _createVNode(_component_router_link, { to: { name: 'admin-tutorial-management' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('tutorial_management')), 1)
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.state.userRole === 'admin')
            ? (_openBlock(), _createBlock("a", {
                key: 17,
                class: _ctx.state.data.activeTab === 17 ? 'nav-link active' : 'nav-link',
                href: "javascript:void(0)",
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.redirectToManageAllTag && _ctx.redirectToManageAllTag(...args)))
              }, [
                _hoisted_35,
                _createVNode(_component_router_link, { to: { name: 'admin-manage-all-tag' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('manage_project_tags')), 1)
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.state.userRole === 'admin')
            ? (_openBlock(), _createBlock("a", {
                key: 18,
                class: _ctx.state.data.activeTab === 21 ? 'nav-link active' : 'nav-link',
                href: "javascript:void(0)",
                onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.redirectToMangaeReferralLink && _ctx.redirectToMangaeReferralLink(...args)))
              }, [
                _hoisted_36,
                _createVNode(_component_router_link, { to: { name: 'manage-referral-link' } }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('manage_referral_link')), 1)
                  ]),
                  _: 1
                })
              ], 2))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}